import type { FaireProductEntity } from "../../entity_types/product";

export const p_k6ajkpvcpb: FaireProductEntity = {
  token: "p_k6ajkpvcpb",
  type: "product",
  name: "Bamboo Matcha Whisk (Long Handle) - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/a5c8c5eddcd0a9acd794eceff0b2f3ec19a3faafa9ccefca31ca03717993e0d8.png",
  galleryImageUrls: [],
  priceDollars: 11,
  description: "Whisk Easy\n\nThe perfect matcha latte is only a whisk away!\n\nDesigned for your daily matcha enjoyment, this stunning black bamboo whisk makes the perfectly smooth cup of matcha with ease. \n\nIt's extra long skinny handle makes it perfect for fitting into any of your favourite glasses or mugs. \n\nHow to Make the Perfect Matcha Latte \n\nIn your favourite mug, add 1 tsp Lake & Oak Purely Matcha or Mega Matcha powder. Add a splash of water and whisk in a zig-zag motion, until the matcha is dissolved and tiny bubbles form. Sweeten to taste and top with 1 cup of frothed milk\n\nCare instructions \n\nRinse whisk with warm water after each use and let dry.\n\n",
  tags: [],
  msrpDollars: 18.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:42.020Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
